import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, Table, Modal, Badge } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
// import "../../../node_modules/react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileDownload, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import * as Common from '../../Common';
import Dialog from '../../Dialog';
// import '../../../mcss/common.css';
import RequestHeader from '../RequestHeader';
import $ from 'jquery';
import Ad1RequestHeader from './Ad1RequestHeader';
import { faEye } from '@fortawesome/free-regular-svg-icons';
import AD1TransactionComment from './AD1TransactionComment';


function Ad1FinalDocUpload(props) {
    const navigate = useNavigate();
    const [refreshCounter, setRefreshCounter] = useState(0);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [reqSrNo, setReqSrNo] = useState(0);
    const [reqQuantity, setReqQuantity] = useState(0);
    const [reqCoverBank, setReqCoverBank] = useState("0");
    const [ddCoverBank, setDdCoverBank] = useState([]);
    const [reqCoverBankName, setReqCoverBankName] = useState("");
    const [reqCoverValue, setReqCoverValue] = useState("");
    const [coverListData, setCoverListData] = useState([]);
    const [reqCoverTotValue, setReqCoverTotValue] = useState(0);
    // const [reqData, setReqData] = useState([]);
    const [showReject, setShowReject] = useState(false);
    const [rightAprovQty, setRightAprovQty] = useState([]);
    const [showConfirmBox, setShowConfirmBox] = useState(false);
    const [remark, setRemark] = useState("");
    const [viewObj, setViewObj] = useState("");
    const [reqDocVerify, setReqDocVerify] = useState([]);
    const [reqPurpose, setReqPurpose] = useState("0");
    const [reqDocId, setReqDocId] = useState("0");
    const [ddReqDocOptions, setDdReqDocOptions] = useState([]);
    const [reqDocRemark, setReqDocRemark] = useState("");
    const [docListData, setDocListData] = useState([]);
    const [reqDocumentsFinal, setReqDocumentsFinal] = useState(0);
    const [documentToView, setDocumentToView] = useState("");
    const [documentTypeToView, setDocumentTypeToView] = useState("");
    const [documentDescToView, setDocumentDescToView] = useState("");
    const [documentNameToView, setDocumentNameToView] = useState("");
    const [showDocument, setShowDocument] = useState(false);


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'AD1FINALDOCUPLOAD'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                    Common.callApi(Common.apiAd1, [sid, 'view', JSON.stringify({ srno: props.srno })], function (result) {
                        let resp = JSON.parse(result);
                        console.log(resp);
                        setViewObj(resp[0]);
                        setReqCoverBank(resp[0].trad_bank_code);
                        setReqCoverValue(resp[0].trad_quantity);
                        setReqSrNo(resp[0].trad_srno);
                        setReqQuantity(resp[0].trad_quantity);
                        setReqPurpose(resp[0]?.trad_purpose);
                        // setReqCoverFinal(resp[0].trad_issuercover);
                        // setReqCoverTotValue(resp[0].trad_quantity);
                        setReqCoverBankName(resp[0].issuer_name);
                        // Common.callApi(Common.apiad1coverrate, [sid, 'list', props.srno], function (result) {
                        //     var arr = JSON.parse(result)
                        //     setCoverListData(arr);
                        //     //add all cbalue to total
                        //     setReqCoverTotValue(arr.reduce((a, b) => a + (b.cvalue * 1), 0));
                        //     setReqCoverTotValue(arr[0].cvalue);
                        // });
                        // Common.callApi(Common.apiAddDetails, [sid, 'kycdoclist', resp[0]?.trad_purpose], function (result4) {
                        //     let resp4 = JSON.parse(result4);
                        //     setDdReqDocOptions(resp4);
                        // });
                    });
                    // Common.callApi(Common.apiIssuer, [sid, 'ddlistjson'], function (result) {
                    //     let parsed = JSON.parse(result || "[]");
                    //     setDdCoverBank(Array.isArray(parsed) ? parsed : []);
                    // });
                    // Common.callApi(Common.apiRight, [sid, 'all', 'APRCHANGEQTY'], function (result1) {
                    //     setRightAprovQty(JSON.parse(result1));
                    // });
                    getDocuments();
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate, props]);

    function getDocuments() {
        Common.callApi(Common.apiAd1, [sid, 'getDoc', JSON.stringify({ srno: props.srno, pageright: 'AD1FINALDOCUPLOAD' })], function (result) {
            let parsed = JSON.parse(result || "[]");
            setDocListData(parsed || []);
        });
    }

    function btnBackClick() {
        props.callAd1();
    }
    // function btnUploadFile() {
    //     $('.loader').show();
    //     if (document.getElementById('fileToUpload').files[0] === undefined) {
    //         $('.loader').hide();
    //         setMsgText("Please select a file to upload.");
    //         setMsgBox(true);
    //     } else {
    //         var tempArray = document.getElementById('fileToUpload').files[0].name.split('.');
    //         if (reqDocId === "0") {
    //             $('.loader').hide();
    //             setMsgText("Please fill document name.");
    //             setMsgBox(true);
    //         } else if (tempArray.length > 2) {
    //             $('.loader').hide();
    //             setMsgText("(.) not allowed in file name.");
    //             setMsgBox(true);
    //         } else if (document.getElementById('fileToUpload').files[0] === undefined) {
    //             $('.loader').hide();
    //             setMsgText("Please select a file to upload.");
    //             setMsgBox(true);
    //         } else if (document.getElementById('fileToUpload').files[0].size > 10 * 1024 * 1024) {  // 10 MB
    //             $('.loader').hide();
    //             setMsgText("Please select a file with in 10 MB size.");
    //             setMsgBox(true);
    //         } else {
    //             var object1 = {
    //                 sid: sid,
    //                 uploadType: 'AD1KYCDOCUMENT',
    //                 srno: props.srno,
    //                 pageright: 'AD1ADDITIONALDETAILS',
    //                 docid: reqDocId,
    //                 remark: reqDocRemark,
    //                 reqCoverBank: reqCoverBank
    //             }
    //             Common.uploadApi(JSON.stringify(object1), 'fileToUpload', function (result) {
    //                 let resp = JSON.parse(result);
    //                 $('.loader').hide();
    //                 if (resp.error === "") {
    //                     setDocListData(resp.docdetail);
    //                     alert(resp.message);
    //                     setReqDocId("0");
    //                     setReqDocRemark("");
    //                 } else {
    //                     alert(resp.error);
    //                 }
    //             });
    //         }
    //     }

    // }

    // function btnDeleteDocumentClick(srno, docid, filename) {
    //     var object1 = {
    //         srno: srno,
    //         filename: filename,
    //         docid: docid
    //     }
    //     Common.callApi(Common.apiInProgress, [sid, 'docremove', JSON.stringify(object1)], function (result) {
    //         let resp = JSON.parse(result);
    //         if (resp.error === "") {
    //             alert(resp.message);
    //         } else {
    //             alert(resp.error);
    //         }
    //         setDocListData(resp.docdetail);
    //     });
    // }

    // function btnDocumentView(srno, filename) {
    //     $('.loader').show();
    //     var object1 = {
    //         srno: srno,
    //         filename: filename
    //     }
    //     Common.callDocumentViewApi(Common.apiInProgress, [sid, 'docview', JSON.stringify(object1)], function (result) {
    //         let resp = JSON.parse(result);
    //         $('.loader').hide();
    //         setDocumentToView(resp.bs64);
    //         setDocumentTypeToView(resp.typ);
    //         setDocumentDescToView(resp.desc);
    //         setDocumentNameToView(resp.fname);
    //         setShowDocument(true);
    //     });
    // }

    // function btnDocumentDownload(srno, filename) {

    //     var object1 = {
    //         srno: srno,
    //         filename: filename
    //     }
    //     Common.callDownloadApiPost(Common.apiInProgress, "post", [sid, 'docdownload', JSON.stringify(object1)]);
    // }
    function btnUploadFile(type, fileId) {
        if (document.getElementById(fileId).files.length === 0) {
            setMsgText('Please select a File.');
            setMsgBox(true);
        } else {
            var object1 = {
                sid: sid,
                uploadType: type,
                srno: props.srno,
                pageright: "AD1FINALDOCUPLOAD",
                docid: (type === 'SWIFT' ? '999' : '998'),
                remark: reqDocRemark
            }
            Common.uploadApi(JSON.stringify(object1), fileId, function (result) {
                let resp = JSON.parse(result);
                // console.log(JSON.stringify(resp, null, ' '));
                if (resp.error === "") {
                    setDocListData(resp.docdetail);
                    setMsgText(resp.message);
                    setMsgBox(true);
                } else {
                    setMsgText(resp.error);
                    setMsgBox(true);
                }
            });
        }
    }

    function btnDocumentView(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDocumentViewApi(Common.apiInProgress, [sid, 'docview', JSON.stringify(object1)], function (result) {
            let resp = JSON.parse(result);
            setDocumentToView(resp.bs64);
            setDocumentTypeToView(resp.typ);
            setDocumentDescToView(resp.desc);
            setDocumentNameToView(resp.fname);
            setShowDocument(true);
        });
    }

    function btnDocumentDownload(srno, filename) {
        var object1 = {
            srno: srno,
            filename: filename
        }
        Common.callDownloadApiPost(Common.apiInProgress, "post", [sid, 'docdownload', JSON.stringify(object1)]);
    }


    return (
        <>
            <div className="divCostumForm">
                <Container fluid>
                    <Row>
                        <Col>
                            <h1>Ad1 Final Doc Upload</h1>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        </Col>
                    </Row>
                    {/* <Row>
                        <Col> */}
                    <Ad1RequestHeader back={btnBackClick} viewData={viewObj}></Ad1RequestHeader>
                    {/* </Col>
                    </Row> */}

                    <Row>
                        <Col>
                            <h5>Documents</h5>
                        </Col>
                    </Row>
                    {
                        userRight.query === "1" &&
                        <Row>
                            <Col>
                                <Form.Group controlId='fileSwift'>
                                    <Form.Label>Swift</Form.Label>
                                    <Form.Control type="file"></Form.Control>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label>Remark</Form.Label>
                                    <Form.Control type="text" value={reqDocRemark}
                                        onChange={(e) => setReqDocRemark(e.target.value)}
                                    ></Form.Control>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>&nbsp;</Form.Label><br></br>
                                        <Button variant="outline-success" size="sm" onClick={(e) => btnUploadFile('SWIFT', 'fileSwift')} >Upload</Button>
                                </Form.Group>
                            </Col>
                            <Col>
                                &nbsp;
                            </Col>
                        </Row>
                    }
                    {userRight.query === "1" ?
                        <Row>
                            <Col>
                                <Form.Group controlId='fileInvoice'>
                                    <Form.Label>Invoice</Form.Label>
                                    <Form.Control type="file"></Form.Control>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group >
                                    <Form.Label>Remark</Form.Label>
                                    <Form.Control type="text" value={reqDocRemark}
                                        onChange={(e) => setReqDocRemark(e.target.value)}
                                    ></Form.Control>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>&nbsp;</Form.Label><br></br>
                                    <Button variant="outline-success" size="sm" onClick={(e) => btnUploadFile('AD1INVOICE', 'AD1fileInvoice')} >Upload</Button>
                                </Form.Group>
                            </Col>
                            <Col>
                                &nbsp;
                            </Col>
                        </Row>
                        : null
                    }
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>

                            <Table responsive striped bordered hover>
                                <thead>
                                    <tr>

                                        <td>Type</td>
                                        <td>Remark</td>
                                        <td>File Name</td>
                                        <td>&nbsp;</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {docListData.map((res) =>
                                        <tr key={res.doc_uploadedat}>
                                            <td className='divHide'>{res.doc_srno}</td>
                                            <td>{res.doc_id + ' : ' + res.doc_type}</td>
                                            <td>{res.doc_remark}</td>
                                            <td>{res.doc_filename}</td>
                                            <td>{res.doc_active == 1 ? "ACTIVE" : "INACTIVE"}</td>
                                            <td>
                                                <div className="colorThemeBlue">
                                                    <span className="handCursor" onClick={(e) => btnDocumentView(res.doc_srno, res.doc_filename)}>
                                                        <FontAwesomeIcon icon={faEye} />
                                                    </span>&nbsp;
                                                    <span className="handCursor" onClick={(e) => btnDocumentDownload(res.doc_srno, res.doc_filename)}>
                                                        <FontAwesomeIcon icon={faFileDownload} />
                                                    </span>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                    <Row className='border-bottom'>
                        <Col>&nbsp;</Col>
                    </Row>
                    <Row>
                        <Col>
                            &nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="outline-danger" size="sm" onClick={(e) => btnBackClick()} >Back</Button>&nbsp;
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <AD1TransactionComment srno={props.srno} rc={refreshCounter}></AD1TransactionComment>
                        </Col>
                    </Row>
                </Container>
            </div>
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
            </div>
            <Modal
                show={showDocument}
                onHide={() => setShowDocument(false)}
                size="xl"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {documentDescToView + " : " + documentNameToView}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <embed src={documentToView} type={documentTypeToView} style={{ minHeight: "100vh", minWidth: "100%" }} ></embed>
                    {
                        /*
                        type="image/png" type="application/pdf"
                        width="100%" height="100%"
                        
                        <object data={documentToView} type={documentTypeToView} class="internal">
     
                        </object>
                        */
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}
export default Ad1FinalDocUpload;